"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _reactNumberFormat = require("react-number-format");

var _ = require("../..");

var css = _interopRequireWildcard(require("./CurrencyInputField.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const AddQuickButtons = [{
  value: 5000,
  label: '+5,000'
}, {
  value: 2500,
  label: '+2,500'
}, {
  value: 1000,
  label: '+1,000'
}, {
  value: 100,
  label: '+100'
}];
const WithdrawQuickButtons = [{
  value: 1,
  label: '100%'
}, {
  value: 0.5,
  label: '50%'
}, {
  value: 0.25,
  label: '25%'
}];
/**
 * CurrencyInputField allow users to enter amount of funds
 *
 * It provide automatic number formatting to Indian currency format
 *
 * It is built on top of the InputField component, and accepts all of the
 * InputField's props except 'before', 'variant', 'onChange', 'type', although
 * it's `type` prop is set to "text" and cannot be overridden.
 *
 * For more information, review the InputField's prop interface and
 * documentation.
 */

const CurrencyInputField = /*#__PURE__*/React.forwardRef(({
  after,
  className,
  currentBalance = 0,
  disabled,
  error,
  onChange,
  placeholder = '0.00',
  showQuickButtons = false,
  side = 'add',
  valid,
  value = '',
  controlledByArrowKeys = false,
  step = 1,
  digitsAfterDot,
  ...otherProps
}, ref) => {
  const handleChange = objectValues => {
    if (onChange) onChange(objectValues.value);
  };

  const handleAddClick = buttonValue => {
    if (onChange) onChange("".concat(+value + buttonValue));
  };

  const handleWithdrawClick = buttonValue => {
    if (onChange) onChange("".concat(currentBalance * buttonValue));
  };

  const handleKey = event => {
    const key = event.key || event.keyCode;
    const isUpKey = key === 'ArrowUp' || key === 38;
    const isDownKey = key === 'ArrowDown' || key === 40;
    const inputValue = event.currentTarget.value.replaceAll(',', '');

    if (isUpKey && onChange) {
      onChange("".concat((+inputValue + step).toFixed(4)));
    } else if (isDownKey && onChange) {
      onChange("".concat((+inputValue - step).toFixed(4)));
    }
  };

  const onKeyDown = React.useMemo(() => controlledByArrowKeys ? handleKey : () => null, [controlledByArrowKeys]);
  const inputRef = React.useRef(null);

  const handlePencilClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (0, _pragma.createFelaElement)(_.View, {
    className: className,
    flexDirection: "column",
    gap: "medium"
  }, (0, _pragma.createFelaElement)(_.InputField, _extends({
    after: !error && !valid && (after || (0, _pragma.createFelaElement)(_.EditIcon, {
      cursor: "pointer",
      onClick: handlePencilClick,
      color: disabled ? 'disabled.3' : 'text.1',
      size: "large"
    })),
    before: (0, _pragma.createFelaElement)(_.RupeeIcon, {
      color: disabled ? 'disabled.3' : 'text.2',
      size: "large"
    }),
    disabled: disabled,
    error: error,
    InputProps: { ...(otherProps.InputProps ? otherProps.InputProps : {}),
      as: _.NumberInput,
      css: css.inputWrapper,
      onValueChange: handleChange,
      onKeyDown,
      value,
      digitsAfterDot
    },
    placeholder: placeholder,
    ref: ref || inputRef,
    valid: valid
  }, otherProps, {
    showValidationIcons: true,
    variant: "secondary"
  })), showQuickButtons && side === 'add' && (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "row",
    gap: "xsmall"
  }, AddQuickButtons.map(({
    label,
    value: buttonValue
  }) => (0, _pragma.createFelaElement)(_.Button, {
    children: label,
    disabled: disabled,
    key: label,
    onClick: () => handleAddClick(buttonValue),
    size: "small",
    variant: "secondary"
  }))), showQuickButtons && side === 'withdraw' && (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "row",
    gap: "xsmall"
  }, WithdrawQuickButtons.map(({
    label,
    value: buttonValue
  }) => (0, _pragma.createFelaElement)(_.Button, {
    children: label,
    disabled: disabled,
    key: label,
    onClick: () => handleWithdrawClick(buttonValue),
    size: "small",
    variant: "secondary"
  }))));
});
CurrencyInputField.displayName = 'CurrencyInputField';
var _default = CurrencyInputField;
exports.default = _default;
//# sourceMappingURL=CurrencyInputField.js.map